module.exports = __webpack_public_path__ + "static/media/lamps-plus-large.5c1c129b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/lamps-plus-large.png
// module id = 835
// module chunks = 27